export default __webpack_public_path__ + "static/media/digitalcard_ticket.7466fa84.svg";